import { render, staticRenderFns } from "./intelligentAudit.vue?vue&type=template&id=f120f102&scoped=true"
import script from "./intelligentAudit.vue?vue&type=script&lang=js"
export * from "./intelligentAudit.vue?vue&type=script&lang=js"
import style0 from "./intelligentAudit.vue?vue&type=style&index=0&id=f120f102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f120f102",
  null
  
)

export default component.exports